import {
  HelpMenu as HelpMenuComponent,
  NavMenuLink as MenuLink,
} from '@apps-common/ui-components/NavBar/index.js';
import {MenuItem} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

import {startTour} from '@explorer/actions/tour';
import {trackEvent} from '@explorer/analytics';

const HelpMenu = ({startTour, ...props}) => {
  const {t} = useTranslation();

  const onTourStart = () => {
    trackEvent('Take a Tour button clicked');
    startTour();
  };

  return (
    <HelpMenuComponent {...props}>
      <MenuLink
        href="https://developers.planet.com/docs/apps/explorer/"
        data-qe="user-guide"
      >
        {t('navbars.menuGuide')}
      </MenuLink>
      <MenuItem onClick={onTourStart} data-qe="take-tour">
        {t('navbars.menuTour')}
      </MenuItem>
    </HelpMenuComponent>
  );
};

HelpMenu.propTypes = {
  startTour: PropTypes.func,
};

const mapDispatchProps = {
  startTour,
};

export default connect(null, mapDispatchProps)(HelpMenu);
